export default {
  xui: {
    approval: {
      common: {
        character: '字'
      },
      labels: {
        result: '审批结果'
      },
      simpleApproval: {
        labels: {
          approval: '同意',
          reject: '驳回',
          handover: '转审'
        }
      },
      fullApproval: {
        labels: {
          approval: '同意',
          reject: '驳回',
          handover: '转他人处理',
          result: '验收意见'
        }
      },
      simpleApprovalHandover: {
        labels: {
          transactor: '处理人',
          advice: '转审意见'
        },
        message: {
          transactor: '',
          advice: ''
        }
      },
      simpleApprovalApproval: {
        labels: {
          copy: '抄送',
          advice: '审批意见'
        },
        message: {
          copy: '',
          advice: ''
        }
      },
      simpleApprovalReject: {
        labels: {
          copy: '抄送',
          advice: '审批意见'
        },
        message: {
          copy: '',
          advice: ''
        }
      },
      fullApprovalApproval: {
        labels: {
          radio: '是否有遗留整改',
          radio_yes: '是',
          radio_no: '否',
          content: '遗留整改内容',
          comment: '备注'
        },
        message: {
          radio: '',
          content: '',
          comment: ''
        }
      },
      fullApprovalHandover: {
        labels: {
          transactor: '转处理人'
        },
        message: {
          transactor: ''
        }
      },
      fullApprovalReject: {
        labels: {
          reason: '驳回原因'
        },
        message: {
          reason: ''
        }
      },
      region: {
        placeholder: '请选择地区部和代表处',
        changeArea: '选择地区部',
        changeBranch: '选择代表处',
        search: '搜索全部',
        select: '选择',
        area: '地区部',
        country: '国家',
        branch: '代表处',
        all: '显示全部',
        defaults: '默认',
        searchMore: '过多结果，请优化搜索',
        selectAll: '全选',
        reset: '重置',
        chart: '，'
      },
      product: {
        placeholder: '请选择产品线和产品域',
        changeArea: '选择产品线',
        changeBranch: '选择产品域',
        search: '搜索全部',
        select: '选择',
        line: '产品线',
        area: '产品域',
        serial: '产品',
        spu: '传播名'
      }
    },
    district: {
      placeholder: '请选择',
      country: {
        title: '选择国家/地区',
        placeholder: '搜索国家'
      },
      province: {
        title: '选择省份/州',
        placeholder: '搜索省份'
      },
      city: {
        title: '选择城市',
        placeholder: '搜索城市'
      },
      county: {
        title: '选择区县',
        placeholder: '搜索区县'
      },
    },
    input: {
      common: {
        character: '字'
      }
    },
    currency: {
      placeholder: '请输入金额'
    },
    intro: {
      next : '下一步',
      back : '上一步',
      skip : '跳过',
      done : '完成',
    },
    charts: {
      cancel:"取消",
      confirm: '确认',
      columnTitle:"图例",
      dialogTitle:"选择图例",
      know: '知道了',
      legendbarPlaceholder: '请输入关键字',
      more: '更多',
      panelHeaderTitle:"可选项",
      reset:"重置",
      search: '搜索',
      tip: '请选择 {min} ~ {max} 个选项',
      transferTip: '最多可以选择{max}个选项',
      tiptitle: '消息提示',
      panelHeaderTitleFit: "可选项 ({checked}/{max})",
      panelHeaderTitleMax: "可选项已满 ({checked}/{max})",
      transferTipMin: '最少选择{min}个选项'
    }
  },
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      weekToDate: '周至今',
      monthToDate: '月至今',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      week: '周',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无搜索结果',
      noData: '暂无数据',
      placeholder: '请选择',
      all: '全部',
      reset:"重置"
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      noData: '暂无数据',
    },
    pagination: {
      goto: '前往',
      pagesize: '条。',
      perPage: '每页',
      total: '显示第 {startNumber} ~ {endNumber} 条记录，共 {total} 条。',
      simpleTotal: '总记录数 : {total} 条。',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传',
      cancel: '取消',
      reupload: '重新上传'
    },
    table: {
      emptyText: '无符合查询条件的记录。',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计',
      confirm: '确认',
      cancel: '取消',
      checkedAll: '全选',
      empty: '(空白)'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项', // to be translated
      leftFixed: '左固定',
      rightFixed: '右固定',
      moveUp: '上移',
      moveDown: '下移',
      all: '所有',
      selected: '已选',
      title: '列表设定',
      toolbarTitles: ['未显示', '已显示'],

    },
    toolbar: {
      leftFixed: '左固定',
      rightFixed: '右固定',
      moveUp: '上移',
      moveDown: '下移',
      hide: '隐藏',
      show: '显示',
      title: '列表设定',
      toolbarTitles: '列表栏位',
      placeholder: '请输入关键字',
      cancel: '取消',
      confirm: '确认',
      reset:'重置',
      top: '置顶',
      bottom: '置底',
      dragTip: '拖拽表格行可调整顺序'
    },
    user: {
      placeholder: '请输入姓名拼音或工号',
      userPlaceholder : "请选择人员",
      userSearchPlaceholder : "请输入姓名拼音或工号",
      employeeExists: '该人员已存在'
    },
    share: {
      title: '分享'
    },
    form:{
      collapse: '收起更多',
      more: '显示更多'
    },
    conditionSearch: {
      setDefaultCondition:"设为默认条件",
      cancelDefaultCondition:"取消默认",
      cancelDefaultConditionFailed:"取消默认失败,请重试",
      setDefaultConditionFailed:"设置默认失败,请重试",
      default:"默认",
      addNewCondiotion:"另存为新的条件模板",
      conditionTemplate:"条件模板",
      noConditionData:"无保存的条件模板",
      deleteC: '清空组合',
      cancelDelete: '取消清空',
      Reset: '重置',
      StorageCondition: '保存条件',
      Search: '搜索',
      name: '名称',
      setDefaultLabel: '使此项成为我在此页的默认值',
      cancel: '取消',
      confirm: '确定',
      saveLimit: "您已超出限制，最多保存50条定制",
      error: "错误",
      close: "关闭",
      saveFailed: "保存失败,请重试",
      know: '知道了',
      saveSuccess: "保存成功",
      success:"成功",
      sameName: "已存在具有相同名称的保存定制，是否将其替换？",
      tips: "提示",
      confirmDeletion:"是否确定要删除条件组合？",
      more:"更多搜索条件",
      showMore: "显示更多",
      collapseMore: '收起更多',
      nameCannotBeEmpty: "名称不能为空",
      nameLength: "长度不能超过30个汉字",
      searchMore: "过多结果，请优化搜索"
    },
    deliveryGroup: {
      collapse: '收起',
      more: '更多'
    },
    deliveryForm: {
      bar: {
        clearAll: '清空条件'  
      }
    },
    image: {
      error: "加载失败"
    },
    calendar: {
      allDay: '全天',
      today: '今',
      day: '天',
      week: '周',
      month: '月',
      calendar: '日历',
      weekDay: {
        '0': '星期日',
        '1': '星期一',
        '2': '星期二',
        '3': '星期三',
        '4': '星期四',
        '5': '星期五',
        '6': '星期六',
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js